import { Component } from '@angular/core';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { apiService } from 'app/services/api.service';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, Observer, catchError, map, of, startWith, switchMap } from 'rxjs';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';
import { B2cGlobalDataService } from 'app/services/b2cGlobalData.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-hotel-search',
  templateUrl: './hotel-search.component.html',
  styleUrls: ['./hotel-search.component.scss'],
})
export class HotelSearchComponent {
  isRtl: boolean;
  selected: any = {};
  hotelSearchForm: FormGroup;
  minDate: Date;
  bsValue = new Date();
  tomorrowDate: Date;
  checkInDate: Date;
  checkOutDate: Date;
  fromDestinationError = false;
  checkInDateError = false;
  checkOutDateError = false;

  constructor(private api: apiService, private b2cGlobalDataService: B2cGlobalDataService, private fb: FormBuilder, private router: Router) {
    this.minDate = new Date();
    const today = new Date();
    this.checkInDate = today;
    this.checkOutDate = new Date(today);
    this.checkOutDate.setDate(today.getDate() + 1);
  }

  contentdropdown: boolean = false;
  contentdropdownRooms: boolean = false;

  ngOnInit(): void {
    this.hotelSearchForm = this.fb.group({
      fromDestination: [null, Validators.required],
      checkInDate: [null, Validators.required],
      checkOutDate: [null, Validators.required],
      rooms: this.fb.array([]),
    });
    console.log('rooms', this.rooms)
  }

  formatDate(date = new Date()) {
    const year = date.toLocaleString('default', { year: 'numeric' });
    const month = date.toLocaleString('default', {
      month: '2-digit',
    });
    const day = date.toLocaleString('default', { day: '2-digit' });

    return [year, month, day].join('-');
  }

  onSearchButtonClick() {
    if (this.hotelSearchForm) {
      const fromDestination = this.hotelSearchForm.get('fromDestination')?.value;
      const checkInDate = this.formatDate(this.hotelSearchForm.get('checkInDate')?.value);
      const checkOutDate = this.formatDate(this.hotelSearchForm.get('checkOutDate')?.value);

      const roomsDataString = this.rooms.map((room, roomIndex) => {
        const childAgesString = this.getSelectedChildAgesString(roomIndex);
        return `id-${room.id}_adult-${room.adults}_children-${room.children}${childAgesString ? `_ages-${childAgesString}` : ''}`;
      }).join('/');

      if (!fromDestination) {
        this.fromDestinationError = true;
        return;  // Stop further execution if there's an error
      }
      if (!checkInDate) {
        this.checkInDateError = true;
        return;  // Stop further execution if there's an error
      }
      if (!checkOutDate) {
        this.checkOutDateError = true;
        return;  // Stop further execution if there's an error
      }

      // Reset error state if fromDestination is filled
      this.fromDestinationError = false;

       // Extract cityCode from the combined value
    const [, cityCode] = fromDestination.split(', ');

      // Construct the query parameters
      const queryParams = {
        cityCode,
        checkInDate,
        checkOutDate,
        room: roomsDataString,
      };

      // Navigate to the "hotel/list" route with query parameters
      this.router.navigate(['/hotel/list'], { queryParams }).then(() => {
        // Manually replace the encoded character in the URL
        const currentUrl = window.location.href;
        const updatedUrl = currentUrl.replace(/%2F/g, '/');
        window.history.replaceState({}, '', updatedUrl);
      });
    }
  }

  getSelectedChildAgesString(roomIndex: number): string {
    const selectedChildAges = [];
    for (let childIndex = 0; childIndex < this.rooms[roomIndex].children; childIndex++) {
      const selectBox = document.getElementById(`selectbox${roomIndex + 1}_${childIndex + 1}`) as HTMLSelectElement;
      if (selectBox) {
        const selectedAge = selectBox.options[selectBox.selectedIndex].getAttribute('data-age') || '0';
        selectedChildAges.push(selectedAge);
      }
    }
    return selectedChildAges.join('-');
  }



  updateCheckOutDate(selectedDate: Date): void {
    // Update checkOutDate to be at least one day after the selected check-in date
    this.checkOutDate = new Date(selectedDate);
    this.checkOutDate.setDate(selectedDate.getDate() + 1);
  }

  showDropdown = false;
  searchInput = '';
  apiResponse: any;

  onInputChanged(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.searchInput = value;
    this.showDropdown = value.length >= 3;

    if (this.showDropdown) {
      this.getHotelAutoSearch();
    }
  }


  getHotelAutoSearch() {
    const query = this.searchInput;
    const languageCode = 'en';
    const user_login_token = localStorage.getItem('apiLoginToken');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${user_login_token}`);

    this.api.getHotelAutoSearch(query, languageCode, headers).subscribe(
      (data) => {
        this.apiResponse = data;
        this.showDropdown = this.apiResponse.success && this.apiResponse.data.length > 0;
      },
      (error) => {
        console.error('Error in Hotel search API:', error);
      }
    );
  }

  selectDestination(destination: string, cityCode: string) {
    const combinedValue = `${destination}, ${cityCode}`;
    this.hotelSearchForm!.get('fromDestination')!.setValue(combinedValue);
    this.showDropdown = false;
}


  hotelClass: any = [
    {
      id: 0,
      displayName: 'Super Delux',
      name: 'Super Delux',
    },
    {
      id: 1,
      displayName: 'Delux',
      name: 'Delux',
    },
    {
      id: 2,
      displayName: 'Premium',
      name: 'Premium',
    },
  ];

  hotelRoomClass: any = [
    {
      id: 0,
      displayName: 'Bed Only',
      name: 'Bed Only',
    },
    {
      id: 1,
      displayName: 'Bed and Breakfast',
      name: 'Bed and Breakfast',
    },
    {
      id: 2,
      displayName: 'Breakfast + Lunch',
      name: 'Breakfast + Lunch',
    },
    {
      id: 3,
      displayName: 'Breakfast + Lunch + Dinner',
      name: 'Breakfast + Lunch + Dinner',
    },
    {
      id: 4,
      displayName: 'Lunch + Dinner',
      name: 'Lunch + Dinner',
    },
    {
      id: 5,
      displayName: 'All Inclusive',
      name: 'All Inclusive',
    },
  ];

  selectedHotelClass: string = 'Super Delux';
  selectedRoomClass: string = 'Bed Only';
  colorvariable: number = 0;

  changeCode(arr: any) {
    this.selectedHotelClass = arr.name.replace('_', ' ');
    this.colorvariable = arr.id;
  }

  changeCodeRooms(arr: any) {
    this.selectedRoomClass = arr.name.replace('_', ' ');
    this.colorvariable = arr.id;
  }

  dropdownOpen() {
    this.contentdropdown = !this.contentdropdown;
  }
  dropdownOpenRoom() {
    this.contentdropdownRooms = !this.contentdropdownRooms;
  }

  bsConfig = {
    dateInputFormat: 'DD-MM-YYYY',
    containerClass: 'theme-red',
    showWeekNumbers: false,
  };


  // travelers functionality

  isTravellersInfoVisible = false;
  maxRooms = 4;
  maxAdults = 10;
  maxChildren = 6;

  rooms = [
    { id: 1, title: 'Room 1', adults: 1, children: 1, isCollapsed: true },
    // You can add more rooms with default values if needed
  ];

  toggleTravellersInfoDrop() {
    this.isTravellersInfoVisible = !this.isTravellersInfoVisible;
  }

  addRoom() {
    if (this.rooms.length < this.maxRooms) {
      const newRoomId = this.rooms.length + 1;

      // Define the type for newRoom including the childAges property
      type RoomWithChildAges = {
        id: number;
        title: string;
        adults: number;
        children: number;
        isCollapsed: boolean;
        childAges: string;
      };

      // Create a new room object with default values
      const newRoom: RoomWithChildAges = {
        id: newRoomId,
        title: `Room ${newRoomId}`,
        adults: 2,
        children: 0,
        isCollapsed: true,
        childAges: this.getDefaultChildAges(),
      };

      this.rooms.push(newRoom);
    }
  }

  getDefaultChildAges(): string {
    const defaultChildAges = [];
    for (let i = 0; i < this.maxChildren; i++) {
      defaultChildAges.push('0'); // Assuming the default age is '0' for each child
    }
    return defaultChildAges.join('-');
  }


  removeRoom(index: number) {
    // Ensure that Room 1 is not deletable
    if (index > 0) {
      this.rooms.splice(index, 1);
    }
  }

  isAddRoomDisabled(): boolean {
    return this.rooms.length >= this.maxRooms;
  }

  toggleRoomCollapse(index: number) {
    this.rooms[index].isCollapsed = !this.rooms[index].isCollapsed;
  }

  getTotalTravelers(room: any): number {
    return room.adults + room.children;
  }

  incrementAdults(room: any) {
    if (room.adults < this.maxAdults) {
      room.adults++;
    }
  }

  decrementAdults(room: any) {
    if (room.adults > 1) {
      room.adults--;
    }
  }

  incrementChildren(room: any) {
    if (room.children < this.maxChildren) {
      room.children++;
    }
  }

  decrementChildren(room: any) {
    if (room.children > 0) {
      room.children--;
    }
  }

  getRange(count: number): number[] {
    return new Array(count).fill(0).map((_, index) => index);
  }

  getTotalRoomsAndTravelersText(): string {
    const totalRooms = this.rooms.length;
    const totalTravelers = this.rooms.reduce(
      (sum, room) => sum + room.adults + room.children,
      0
    );

    return `${totalRooms} Room${
      totalRooms > 1 ? 's' : ''
    } | ${totalTravelers} Traveler${totalTravelers > 1 ? 's' : ''}`;
  }
}
